import { render, staticRenderFns } from "./necessity.vue?vue&type=template&id=3204a88a&scoped=true&"
import script from "./necessity.vue?vue&type=script&lang=js&"
export * from "./necessity.vue?vue&type=script&lang=js&"
import style0 from "./necessity.vue?vue&type=style&index=0&id=3204a88a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204a88a",
  null
  
)

export default component.exports